import React, { forwardRef, ReactNode } from 'react'

import { styled } from '@linaria/react'

import { WithDataName } from 'common/types'
import { breakpoints } from 'components/designSystem/shared/breakpoints'

interface ProfileCard {
  personalBlock: ReactNode
  targetBlock: ReactNode
  locationBlock: ReactNode
  aboutBlock?: ReactNode
  jobBlock?: ReactNode
  educationBlock?: ReactNode
  tagsBlock?: ReactNode
  languagesBlock?: ReactNode
  travelBlock?: ReactNode
  lifestyleBlock?: ReactNode
  appearanceBlock?: ReactNode
  astroBlock?: ReactNode
  footerWave: ReactNode
  mobileGoalPhoto?: ReactNode
  mobileInterestsPhoto?: ReactNode
  mobileSocialPhoto?: ReactNode
  mobilePhotos?: ReactNode
}

export const ProfileCard = forwardRef<
  HTMLDivElement,
  ProfileCard & WithDataName
>(
  (
    {
      personalBlock,
      targetBlock,
      locationBlock,
      aboutBlock,
      jobBlock,
      educationBlock,
      tagsBlock,
      languagesBlock,
      travelBlock,
      lifestyleBlock,
      appearanceBlock,
      astroBlock,
      footerWave,
      mobileGoalPhoto,
      mobileInterestsPhoto,
      mobileSocialPhoto,
      mobilePhotos,
      ...rest
    },
    ref
  ) => {
    return (
      <Parent ref={ref} data-name={rest['data-name']}>
        <ParentBlockDesktop>{personalBlock}</ParentBlockDesktop>
        <ParentBlock>{targetBlock}</ParentBlock>
        <ParentBlock>{locationBlock}</ParentBlock>
        {aboutBlock && <ParentBlockAbout>{aboutBlock}</ParentBlockAbout>}
        {jobBlock && <ParentBlock>{jobBlock}</ParentBlock>}
        {educationBlock && <ParentBlock>{educationBlock}</ParentBlock>}
        {mobileGoalPhoto && (
          <ParentBlockMobile>{mobileGoalPhoto}</ParentBlockMobile>
        )}
        {tagsBlock && <ParentBlock>{tagsBlock}</ParentBlock>}
        {languagesBlock && <ParentBlock>{languagesBlock}</ParentBlock>}
        {travelBlock && <ParentBlock>{travelBlock}</ParentBlock>}
        {mobileInterestsPhoto && (
          <ParentBlockMobile>{mobileInterestsPhoto}</ParentBlockMobile>
        )}
        {lifestyleBlock && <ParentBlock>{lifestyleBlock}</ParentBlock>}
        {mobileSocialPhoto && (
          <ParentBlockMobile>{mobileSocialPhoto}</ParentBlockMobile>
        )}
        {appearanceBlock && <ParentBlock>{appearanceBlock}</ParentBlock>}
        {astroBlock && <ParentBlock>{astroBlock}</ParentBlock>}
        {mobilePhotos && <ParentBlockMobile>{mobilePhotos}</ParentBlockMobile>}
        {footerWave}
      </Parent>
    )
  }
)

const Parent = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-gap: var(--spacing-32px);
  gap: var(--spacing-32px);
  height: max-content;
  position: relative;
  padding: var(--spacing-32px) 0 0 0;

  @media screen and (min-width: ${breakpoints.mobile + 1}px) {
    padding: var(--spacing-32px) var(--spacing-24px) 0 var(--spacing-24px);
  }
`

const ParentBlock = styled.div`
  padding: 0 var(--spacing-24px);
`

const ParentBlockAbout = styled.div`
  padding: 0 var(--spacing-4px);

  @media screen and (max-width: ${breakpoints.mobile}px) {
    padding: 0 var(--spacing-12px);
  }
`

const ParentBlockMobile = styled.div`
  display: none;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    display: block;
    padding: 0 var(--spacing-12px);
  }
`

const ParentBlockDesktop = styled.div`
  padding: 0 var(--spacing-24px);

  @media screen and (max-width: ${breakpoints.mobile}px) {
    display: none;
  }
`
